<div class="step-choice">
  <div class="choice-grid">
    <!-- AI Card (highlighted) -->
    <div
      class="choice-card choice-card--ai choice-card--selected"
      (click)="service.goToStep(1)"
      role="button"
      tabindex="0"
      (keydown.enter)="service.goToStep(1)"
      (keydown.space)="service.goToStep(1)"
    >
      <div class="choice-icon choice-icon--ai">✦</div>
      <h3 class="choice-label">Create with AI</h3>
      <p class="choice-credits" [class.choice-credits--empty]="!service.hasAiImageCredits()">
        <span class="choice-credits__count">{{ service.aiImageCredits() ?? 0 }}</span>
        AI Image credits left
      </p>
      <p class="choice-desc">Generate a full week of posts from your website or business info</p>
    </div>

    <!-- Manual Card -->
    <div
      class="choice-card choice-card--manual"
      (click)="onManualCreate()"
      role="button"
      tabindex="0"
      (keydown.enter)="onManualCreate()"
      (keydown.space)="onManualCreate()"
    >
      <div class="choice-icon choice-icon--manual">✏</div>
      <h3 class="choice-label">Manual create</h3>
      <p class="choice-desc">Write and schedule posts yourself with full control</p>
    </div>
  </div>

  <!-- Info bar -->
  <div class="info-bar">
    <span class="info-bar__icon">⚡</span>
    <p class="info-bar__text">
      AI uses your prompt (and optional website) to generate posts and images. Then choose accounts,
      set dates, and schedule or save as drafts.
    </p>
  </div>
</div>
